<template>
  <div :class="s.partnerWrap">
    <div :class="s.partner">
      <img :src="item" alt="" v-for="(item, index) in imgs" :key="index" />
    </div>
  </div>
</template>

<script>
const imgs = [
  require("../images/partner.png"),
  require("../images/pinan.png"),
  require("../images/renshou.png"),
  require("../images/taipingyang.png"),
  require("../images/dadi.png"),
];
export default {
  computed: {
    s() {
      return this.$style;
    },
  },
  data() {
    return {
      imgs,
    };
  },
};
</script>

<style scoped lang="less" module>
.partnerWrap {
  width: 100%;
  background-color: #fff;
  overflow: hidden;
  margin-top: 60px;
}
.partner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 1075px;
  margin: 0 auto;
  img {
    height: 64px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/components/Partners.vue